import { useState, useRef, useEffect, useCallback } from 'react';
import { Download, FileText, FileSpreadsheet, Loader2 } from 'lucide-react';

export interface ExportDropdownProps {
  onExportCSV: () => void;
  onExportPDF: () => void;
  loading?: boolean;
}

export function ExportDropdown({ onExportCSV, onExportPDF, loading }: ExportDropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleCSV = useCallback(() => {
    setOpen(false);
    onExportCSV();
  }, [onExportCSV]);

  const handlePDF = useCallback(() => {
    setOpen(false);
    onExportPDF();
  }, [onExportPDF]);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        disabled={loading}
        className="flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 disabled:opacity-60"
      >
        {loading ? (
          <Loader2 size={16} className="animate-spin" />
        ) : (
          <Download size={16} />
        )}
        Exportar
      </button>
      {open && (
        <div className="absolute right-0 top-full z-10 mt-1 w-48 rounded-lg border border-border bg-card shadow-lg">
          <button
            onClick={handleCSV}
            className="flex w-full items-center gap-2 px-4 py-2.5 text-sm hover:bg-muted"
          >
            <FileSpreadsheet size={16} />
            Exportar CSV
          </button>
          <button
            onClick={handlePDF}
            className="flex w-full items-center gap-2 px-4 py-2.5 text-sm hover:bg-muted"
          >
            <FileText size={16} />
            Exportar PDF
          </button>
        </div>
      )}
    </div>
  );
}
